<!-- Side chart with dl -->
@if (!isRendering && type === 'dl') {
  <canvas #chartFOG height="215" width="52"></canvas>
}

<!-- Main chart with data -->
@if (!isRendering && type === 'main') {
  <canvas #chartFOG height="215" width="215"></canvas>
}
